import App from "../Core/App";
import LayoutHelper from "../Helper/Layout";
import AnimationHelper from "../Helper/Animation";

import BaseComponent from "./BaseComponent";

export default class BoxComponent extends BaseComponent {
    constructor() {
        super();

        let app = App.getInstance(),
            em  = app.getEventManager();

        Promise.all([
            this.fixAlignment(),
            this.scanDataTags(true)
        ]).then(function(result) {
            em.emit('doneInitialBoxAnimations');
        })


        this._bindListener( 'click', this._onToggleClick, 'button.blb-box-toggle' );
        em.on('pageLayoutChange', function(data) {
            this.fixAlignment();
            this.scanDataTags();
        }.bind(this));
    }

    /**
     * Parse all conditional data-tags on any .blb-box element, returning a Promise for when all DOM manipulations are finished.
     *
     * @return Promise | null
     */
    scanDataTags(firstRun = false) {
        $('.blb-box').each((i,el) => {
            let d = $(el).data();

            if( d.constructor === Object && d.length < 1 ) return; // Nothing to do

            if( firstRun ) {
                $.when($(el).addClass('skip-animation')).done(() => {
                    this._evaluateDataTags(el);
                    $(el).removeClass('skip-animation');
                });
            } else {
                return Promise.all(this._evaluateDataTags(el));
            }
        });
    }

    /**
     * Subfunction of scanDataTags.
     * Returns a list containing promises for all animations left to perform on this element.
     *
     * @param el jQuery DOM element
     * @return []
     */
    _evaluateDataTags(el) {
        let d = $(el).data();
        let promises = []

        if( typeof d['collapsedOn'] != 'undefined' ) {
            if( _.contains( d['collapsedOn'].split(','), LayoutHelper.getCurrentLayout() ) &&
                !$(el).hasClass('collapsed') ) {
                promises.push( AnimationHelper.toggleBox($(el)) );
            }
        }

        if( typeof d['expandedOn'] != 'undefined' ) {
            if( _.contains( d['expandedOn'].split(','), LayoutHelper.getCurrentLayout() ) &&
                $(el).hasClass('collapsed') ) {
                promises.push( AnimationHelper.toggleBox($(el)) );
            }
        }

        if( typeof d['staticOn'] != 'undefined' ) {
            if( _.contains( d['staticOn'].split(','), LayoutHelper.getCurrentLayout() ) ) {
                $(el).addClass('hide-box-toggle');
            } else {
                $(el).removeClass('hide-box-toggle');
            }
        }

        if( typeof d['noHeaderOn'] != 'undefined' ) {
            if( _.contains( d['noHeaderOn'].split(','), LayoutHelper.getCurrentLayout() ) ) {
                $(el).addClass('hide-box-header');
            } else {
                $(el).removeClass('hide-box-header');
            }
        }

        return promises;
    }

    // Force additional content boxes above blb-box-main, but below subnav and sidebar
    fixAlignment() {
        return new Promise(function(resolve,reject) {
            let cBoxes = $('#blb-content-container').find('.blb-box')
                    .not('.blb-sidebar-1')
                    .not('.blb-sidebar-2')
                    .not('.blb-subnav')
                    .not('.blb-box-main'),
                isSubnav = $('.blb-box.blb-subnav').length > 0,
                isSidebar = $('.blb-box.blb-sidebar-1').length > 0,
                isTwoColumn = $('.blb-box.blb-sidebar-2').length > 0,
                isHome = $('.blb-box-container-home').length > 0,
                row = 1;

            // We don't need to align right column boxes on landing page or 2 column layout
            if( isHome || isTwoColumn ) return;

            if( LayoutHelper.getCurrentLayout() == 'mobile' || LayoutHelper.getCurrentLayout() == 'compact' ) {
                if( isSidebar ) ++row;
                if( isSubnav ) ++row;
            } else {
                if( isSubnav ) ++row;
            }

            cBoxes.each((i,el) => {
                $(el).css('grid-row', row);

                ++row;
            });

            resolve();
        });
    }

    _onToggleClick(event) {
        let app = App.getInstance(),
            el  = $(event.target).parents('.blb-box.blb-box-collapse').first(),
            d   = el.data();

        // Is our box even allowed to toggle in this layout?
        if( typeof d['staticOn'] != 'undefined' ) {
            if( _.contains( d['staticOn'].split(','), LayoutHelper.getCurrentLayout() ) ) return;
        }

        // Workaround for subnav collapse on overlap; Note that subnav is active by default so we can't just toggle
        if( el.hasClass('blb-subnav') ) {
            let top = el.offset().top - $(window).scrollTop();

            if( !el.hasClass('collpased') && top == 0 ) {
                el.addClass('force-active');
            } else {
                el.removeClass('force-active');
            }
        }
        // Exceptions on home (who would have thought)
        if( el.hasClass('blb-box-sidebar') && LayoutHelper.isHome() ) {
            if( el.hasClass('collapsed') && LayoutHelper.getCurrentLayout() == 'compact' ) {
                var h = $($('.blb-box-quadratic')[1]).outerHeight();
                var cols = Math.ceil( $(el).find('.blb-box-content-wrapper').height() / h );
                el.css('grid-row-end', 'span ' + cols)
            }
        }

        // Animation
        AnimationHelper.toggleBox( el ).then(function(){
            if(el.hasClass('blb-box-sidebar') && LayoutHelper.isHome() && el.hasClass('collapsed')) {
                el.css("grid-row-end","");
            }
            if(el.hasClass('blb-box-sidebar') && !LayoutHelper.isCollapsedView()){
                $('.blb-box-absolute').each(function(){
                    if(LayoutHelper.overlaps(el, this)){
                        $(this).hide();
                    } else {
                        $(this).show();
                    }
                });
            }
            if( el.hasClass('blb-subnav') ) {
                app.getComponent('subnav').scrollbar.recalculate();
            }
        });
    }
}
